/*
 * @Descripttion:
 * @version    :
 * @Author     : wuyujiang
 * @Date       : 2024-06-23 10:35
 * @LastAuthor : wuyujiang
 * @LastTime   : 2025-12-19 09:34
 * @Version    : v1.00
 * @desc       :
 */




// 服务端接口


// 正式
const base = process.env.VUE_APP_BASE//"https://api.toptdcloud.com"
const base1 = process.env.VUE_APP_BASE1//"https://api.toptdcloud.com:8443/bd/api" // 老胡（bd代理相关）
const base3 = process.env.VUE_APP_BASE3//"https://api.toptdcloud.com:8443/activity"; // 老胡测试接口

// 测试;

// const base = "https://app.test.7hala.cn"; // 测试接口
// const base1 = "https://app.test.7hala.cn/go/api"; // 老胡测试接口 (bd代理相关)
// const base3 = "https://api.toptdcloud.com:8443/activity_test"; // 老胡测试接口

// const base = "http://3.111.234.67:8000"; // 老胡本地


// old

// const base = "https://app.7hala.cn"; // 正式接口
// const base1 = "https://app.7hala.cn:8443/bd/api/v1"; // 老胡的 正式接口

const allUrl = {
  anniversaryHostsReceive: base + "/agent/effective/hosts/receive", //领取奖励
  anniversaryHostsData: base + "/agent/effective/hosts/data",  //获取代理主播数据
  anniversaryHostsPage: base + "/agent/effective/hosts/page",// 获取主播数据分页.
  anniversaryClaim: base + "/campaign/anniversary/challenge/reward/claim", //挑战奖励领取
  anniversaryPunchIn: base + "/campaign/anniversary/punch/in", //周年打卡
  anniversaryDataOne: base + "/campaign/anniversary/stage1/data",//周年活动1阶段数据.
  guildLevelData: base + "/agent/week/level/data", //数据页
  guildFragmentsExchange: base + "/agent/week/level/fragments/exchange", //碎片兑换
  guildFragmentsStore: base + "/agent/week/level/fragments/store", //碎片商店
  guildRanking: base + "/agent/week/level/ranking", //公会排行榜
  halloweenTask: base + "/campaign/wsj/task", //万圣节任务
  halloweenTaskClaim: base + "/campaign/wsj/task/claim", //万圣节领取
  halloweenLuckyRanking: base + "/campaign/wsj/lucky/ranking", //幸运榜单
  anchor_daily_log: base + "/agent/anchor_daily_log", // 主播每日记录
  userInfo: base + "/user/info/my",
  currencyType: base + "/user/cash/out/currency",
  currencycountryType: base + "/user/cash/out/agent/country/currency",
  paymentMethod: base + "/user/cash/out/payment/method",
  methodField: base + "/user/cash/out/payment/method/field",
  methodFieldContent: base + "/user/cash/out/payment/method/content",
  submitWithdraw: base + "/user/cash/out/payment/method/content/submit",
  anchorEarningsPage: base + "/ranking/anchor/earnings/page",
  anchorEarningsCurrent: base + "/ranking/anchor/earnings/current",
  contributionPage: base + "/ranking/contribution/page",
  contributionCurrent: base + "/ranking/contribution/my",
  exchange: base + "/user/account/anchor/exchange",
  anchorBalancerecord: base + "/user/account/anchor/balance/record/page",
  anchorBalancetypelist: base + "/user/account/anchor/balance/type/list",
  cashoutrecordpage: base + "/user/cash/out/record/page",
  exchangerecordpage: base + "/user/account/anchor/exchange/record/page",
  usercostpage: base + "/ranking/user/cost/page",
  usercostmy: base + "/ranking/user/cost/my",
  userbalance: base + "/user/account/user/balance",
  userbalancerecord: base + "/user/account/user/balance/record/page",
  anchorcenter: base + "/room/anchor/center",
  anchorliverecord: base + "/room/anchor/live/record",
  anchorlivedaydetail: base + "/room/anchor/live/day/detail",
  anchorpointsummary: base + "/room/anchor/point/summary",
  roomanchorstar: base + "/room/anchor/star/",
  roomanchorstardailyrecord: base + "/room/anchor/star/daily_task_record/",
  isStarHost: base + "/room/anchor/is_star_host/",
  agentmanageinfo: base + "/agent/manage/info",
  agentmanageunbind: base + "/agent/manage/anchor/unbind",
  agentbackstagecenter: base + "/agent/backstage/center",
  bdcheck: base1 + "/v1/bd/check",
  agentsellercenter: base + "/agent/seller/center",
  agentsellercenter2: base1 + "/v1/bd/profile",
  removeAnchor: base1 + "/v1/bd/remove_anchor",
  unbindApi: base1 + "/v1/bd/unbind",
  bdcenterData: base1 + "/v1/bd/center",
  bdanchorList: base1 + "/v1/bd/anchor_list",
  bdAgentList: base1 + "/v1/bd/agent_list",
  bdGiftPackage: base1 + "/v1/gift_package/",
  open_or_close_bd: base1 + "/v1/gift_package/open_or_close_bd",
  open_or_close_cs: base1 + "/v1/gift_package/open_or_close_cs",
  get_vip_status: base1 + "/v1/gift_package/vip_status",
  gift_packageGive: base1 + "/v1/gift_package/give",
  bdBdList: base1 + "/v1/bd/bd_list",
  bdcheck2: base1 + "/v2/bd/check",
  agentsellercenter22: base1 + "/v2/bd/profile",
  removeAnchor2: base1 + "/v2/bd/remove_anchor",
  unbindApi2: base1 + "/v2/bd/unbind",
  bdcenterData2: base1 + "/v2/bd/center",
  upgradedAgentApi: base1 + "/v2/bd/upgraded_agents",
  bdanchorList2: base1 + "/v2/bd/anchor_list",
  bdAgentList2: base1 + "/v2/bd/agent_list",
  bdGiftPackage2: base1 + "/v1/gift_package/",
  open_or_close_bd2: base1 + "/v2/gift_package/open_or_close_bd",
  open_or_close_cs2: base1 + "/v2/gift_package/open_or_close_cs",
  get_vip_status2: base1 + "/v2/gift_package/vip_status",
  gift_packageGive2: base1 + "/v2/gift_package/give",
  bdBdList2: base1 + "/v2/bd/bd_list",
  agentbackstagedata: base + "/agent/backstage/data",
  agentbackstageextrareward: base + "/agent/backstage/extra/reward",
  agentinvitation: base + "/agent/manage/invitation",
  agentanchorpage: base + "/agent/manage/anchor/page",
  agentremove: base + "/agent/manage/anchor/remove",
  agentagentpage: base + "/agent/manage/agent/page",
  agentincomepage: base + "/agent/backstage/income/page",
  agentanchordatapage: base + "/agent/backstage/anchor/data/page",
  agentagentdatapage: base + "/agent/backstage/agent/data/page",
  userinfo: base + "/user/info/",
  agentsellerinfo: base + "/agent/seller/info",
  agentselleracceptingchange: base + "/agent/seller/accepting/orders/change", //修改接单状态
  agentsellerpaymentmethods: base + "/agent/seller/payment/methods",
  agentsellerpaymentmethodschange:
    base + "/agent/seller/payment/methods/change",
  agentsellertransfer: base + "/agent/seller/balance/transfer",
  agentsellerexchange: base + "/agent/seller/balance/exchange",
  agentsellerrechargepackage: base + "/agent/seller/balance/recharge/package",
  agentsellerrechargepackagecountry: base + "/agent/seller/balance/recharge/package/country",
  agentsellerrtransferrecord:
    base + "/agent/seller/balance/transfer/record/page",
  agentsellerbalancedetailpage: base + "/agent/seller/balance/detail/page",
  agentsellerrexchangerecord:
    base + "/agent/seller/balance/exchange/record/page",
  agentsellerselectCoinSellerOrderList:
    base + "/agent/seller/order/selectCoinSellerOrderList",
  agentsellerselectCoinSellerOrderInfo: base + "/agent/seller/order/info",
  agentsellerselectCoinSellerOrderrefuse: base + "/agent/seller/order/refuse",
  agentsellerconfirm: base + "/agent/seller/order/confirm",
  agentsellerfinishRemittance: base + "/agent/seller/order/finishRemittance",
  agentsellerupdateScreenshots: base + "/agent/seller/order/updateScreenshots",
  agentsellerpendingCount: base + "/agent/seller/order/pendingCount",
  agentsellerrechargeorderpage:
    base + "/agent/seller/balance/recharge/order/page",
  invitationgamereward: base + "/invitation/game/reward/reward",
  invitationgamerecord: base + "/invitation/game/record",
  invitationgamerecorddetail: base + "/invitation/game/reward/detail/page",
  invitationanchorreward: base + "/invitation/anchor/reward/reward",
  invitationanchorreceivereward:
    base + "/invitation/anchor/reward/receive/reward",
  invitationanchorrecord: base + "/invitation/anchor/record",
  invitationanchorrewardrecord:
    base + "/invitation/anchor/reward/reward/record",
  invitationgamecode: base + "/invitation/game/code",
  invitationanchorcode: base + "/invitation/anchor/code",
  invitationagentcode: base + "/agent/invitation/agent/code",
  invitationoperationcode: base + "/agent/invitation/operation/code",
  systemconfigdetail: base + "/system/config/detail",
  agentsellerordercreate: base + "/agent/seller/balance/recharge/order/create",
  agentsellerordercreateTodo:
    base + "/pay/payin/coin/seller/recharge/order/create",
  agentsellerrechargemethod:
    base + "/agent/seller/balance/recharge/payment/method",
  sellerorderinfo: base + "/pay/payin/coin/seller/recharge/order/info",
  epayordercreate: base + "/pay/epay/coin/seller/recharge/order/create",
  bibiordercreate: base + "/pay/bibi/coin/seller/recharge/order/create",
  agentrechargeamount: base + "/agent/seller/balance/recharge/amount",
  agentsellercurrencydel: base + "/agent/seller/currency/del",
  userinfocheck: base + "/user/info/check/",
  h5paymentmethod: base + "/pay/recharge/h5/payment/method",
  h5currency: base + "/pay/recharge/h5/currency",
  h5package: base + "/pay/recharge/h5/package",
  h5createorder: base + "/pay/order/create/h5",
  h5createorderpayin: base + "/pay/payin/user/recharge/order/create",
  h5Inrordercreate: base + "/pay/inr/recharge/order/create",
  h5Bibiordercreate: base + "/pay/bibi/user/recharge/order/create",
  h5Epayordercreate: base + "/pay/epay/user/recharge/order/create",
  systemswitch: base + "/system/channel/content",
  userexistSecurityCode: base + "/user/pwd/existSecurityCode",
  userverifySecurityCode: base + "/user/pwd/verifySecurityCode",
  campaignredquotacount: base + "/campaign/red/quota/count",
  campaignreddailyquota: base + "/campaign/red/daily/quota",
  campaignredopen: base + "/campaign/red/open",
  campaignrewardsinfo: base + "/campaign/recharge/rewards/info",
  campaignrewardreceive: base + "/campaign/recharge/rewards/receive",
  campaignrankinganchor: base + "/campaign/ranking/anchor",
  campaignrankingagent: base + "/campaign/ranking/agent",
  transferrate: base + "/user/account/anchor/transfer/rate",
  anchortransfer: base + "/user/account/anchor/transfer",
  anchortransferrecordpage: base + "/user/account/anchor/transfer/record/page",
  rankingroomcoinpage: base + "/ranking/room/coin/page",
  rankingroomcoincurrent: base + "/ranking/room/coin/current",
  rankingroompointpage: base + "/ranking/room/point/page",
  rankingroompointcurrent: base + "/ranking/room/point/current",
  rankinggameroompage: base + "/ranking/game/room/page",
  rankinggameroommy: base + "/ranking/game/room/my",
  agentcurrencylist: base + "/agent/seller/currency/list",
  agentsellerpage: base + "/agent/seller/page",
  agentRankConfig: base + "/campaign/agent/gift/earnings/config",
  agentrankingList: base + "/campaign/agent/gift/earnings/ranking",
  roompkranking: base + "/room/pk/winner/contribution/ranking",
  roomstarranking: base + "/ranking/room/star",
  agenteffectivehostspage: base + "/agent/effective/hosts/page",
  agenteffectivehostsdata: base + "/agent/effective/hosts/data",
  agenteffectivehostsreceive: base + "/agent/effective/hosts/receive",
  systeminfosubmit: base + "/system/feedback/h5/info/submit",
  agentlevelcurrent: base + "/agent/level/current",
  agentlevelpage: base + "/agent/level/page",
  roomchath5page: base + "/room/chat/h5/page",
  campaignredluckyValue: base + "/campaign/red/luckyValue",
  agentwelcomesetting: base + "/agent/seller/welcome/setting",
  rankinggamepage: base + "/ranking/game/page",
  rankinggamemy: base + "/ranking/game/my",
  giftreceivingpage: base + "/gift/record/receiving/page",
  balancerecordpage: base + "/user/account/anchor/balance/record/page",
  otherbusinesstypes: base + "/user/account/agent/other/business/types",
  gamebigwinner: base + "/game/big/winner/ranking",
  getfreezebalance: base + "/user/account/anchor/freeze/balance",
  campaigninvitednewdata: base + "/campaign/invited/new/data",
  campaigninvitednewclaim: base + "/campaign/invited/new/claim",
  campaigninvitednewpage: base + "/campaign/invited/new/record/page",
  gameinvestmentrankingday: base + "/game/investment/ranking/day",
  gameinvestmentrankingweek: base + "/game/investment/ranking/week",
  gameblessreceived: base + "/game/bless/bag/today/received",
  gameblessreceiv: base + "/game/bless/bag/receive",
  momentdetail: base + "/moment/manage/detail",
  rechargeweeklyranking: base3 + "/recharge/v1/weekly_ranking",
  hallofcelebrity: base3 + "/recharge/v1/hall_of_celebrity",
  anniversarystage1data: base + "/campaign/anniversary/stage1/data",
  anniversarypunchin: base + "/campaign/anniversary/punch/in",
  anniversaryrewardclaim: base + "/campaign/anniversary/challenge/reward/claim",
  anniversaryHostsPage: base + "/agent/effective/hosts/page",
  anniversaryHostsData: base + "/agent/effective/hosts/data",
  anniversaryHostsReceive: base + "/agent/effective/hosts/receive",
  anniversaryNewData: base + "/campaign/anniversary/invite/new/data",
  anniversaryNewClaim: base + "/campaign/anniversary/invite/new/claim",
  anniversaryNewRecord: base + "/campaign/anniversary/invite/new/record/page",
  anniversaryLuckyRanking: base + "/campaign/anniversary/lucky/ranking",
  anniversaryLuckyRankingmy: base + "/campaign/anniversary/lucky/ranking/my",
  anniversaryrecallinfo: base + "/campaign/anniversary/recall/info",
  anniversaryrecallclaim: base + "/campaign/anniversary/recall/claim",
  anniversaryrecallmy: base + "/campaign/anniversary/recall/my",
  yearReport: base + "/campaign/anniversary/year/report",
  taskClaim: base + "/campaign/anniversary/year/report/task/claim",
  rechargeRanking: base + "/campaign/anniversary/recharge/ranking", //充值榜
  rechargeInfo: base + "/campaign/anniversary/recharge/info", //充值信息
  rewardsRecord: base + "/campaign/anniversary/recharge/rewards/record", //充值奖励记录
  rewardsClaim: base + "/campaign/anniversary/recharge/rewards/claim", //充值奖励领取
  honorClaim: base + "/campaign/anniversary/recharge/honor/claim", //充值勋章领取
  etRechargeRanking: base + "/agent/seller/et/recharge/ranking",
  christmascheckIn: base + "/campaign/christmas/check/in",
  christmascheckInInfo: base + "/campaign/christmas/check/in/info",
  christmasgiftchallengeclaim: base + "/campaign/christmas/gift/challenge/claim",
  campaignrankingchristmasranking: base + "/campaign/ranking/christmas/ranking",
  campaignchristmasjackpotinfo: base + "/campaign/christmas/jackpot/info",
  luckyPartyRanking: base + "/campaign/ranking/lucky/party",
  luckyPartyClaim: base + "/campaign/ranking/lucky/party/claim",

};

export { allUrl };
